<!-- orders.component.html -->


    <ng-container *ngIf="embedded; else standaloneLayout">
  <ng-container *ngTemplateOutlet="ordersContent"></ng-container>
</ng-container>

<ng-template #standaloneLayout>
  <app-layout>
    <ng-container *ngTemplateOutlet="ordersContent"></ng-container>
  </app-layout>
</ng-template>
<ng-template #ordersContent>
<div class="orders-container">
  <!-- ========== HEADER ========== -->


  <!-- ========== SIDEBAR & MAIN CONTENT ========== -->
  <mat-sidenav-container class="sidenav-container">
    <!-- Sidebar -->

    <!-- ========== MAIN CONTENT ========== -->
    <mat-sidenav-content class="main-content">
            <!-- ========== REFRESH NOTIFICATION PANEL (slides in from right) ========== -->
      <div class="refresh-panel" *ngIf="showRefreshPanel" [class.refreshing]="isRefreshingCache">
        <div class="refresh-panel-header">
          <mat-icon class="refresh-panel-icon">notifications_active</mat-icon>
          <span class="refresh-panel-title">Latest Order Detail available</span>
          <button class="refresh-panel-close"
                  (click)="dismissRefreshPanel()"
                  [disabled]="isRefreshingCache"
                  aria-label="Dismiss">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="refresh-panel-body">
          <p>Latest order details are available.<br>The view may remain same if no new order placed from last update</p>
          <p class="refresh-panel-subtext">Click refresh button below to update your view.</p>
          <button class="refresh-panel-button"
                  [disabled]="isRefreshingCache"
                  (click)="onRefreshPanelClick()">
            <mat-spinner *ngIf="isRefreshingCache" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!isRefreshingCache">refresh</mat-icon>
            <span>{{ isRefreshingCache ? 'Refreshing...' : 'Refresh' }}</span>
          </button>
        </div>
      </div>
      
      <!-- Page Header -->
      <div class="page-header">
        <span class="page-title">Orders</span>
      </div>

      <!-- ========== SEARCH SECTION ========== -->
      <mat-label class="search-order-description">
        Search by: Ship-To, Order, Delivery, Customer PO, or PRO Number
      </mat-label>
      <mat-card class="search-card">
        <mat-card-content>
          <div class="search-section">
            <div class="search-box">
              <!-- Search Icon -->
              <span>
                <img src="assets/newimages/SearchIcon.png" alt="">
              </span>
              
              <!-- Search Input -->
              <input 
                type="text" 
                [(ngModel)]="searchValue" 
                matPrefix
                placeholder="Search Orders"
                (keydown.enter)="onSearch()"
                (keydown.tab)="onSearch(); $event.preventDefault()"
                matTooltipPosition="below"
                class="search-input">
              
              <!-- Clear Button -->
              <button 
                mat-icon-button 
                matSuffix 
                matTooltip="Clear"
                matTooltipPosition="below"
                matTooltipShowDelay="500"
                matTooltipHideDelay="100"
                class="clear-button"
                *ngIf="showClearIcon()"
                (click)="clearSearch()"
                tabindex="-1"
                type="button">
                <mat-icon>close</mat-icon>
              </button>
              
              <!-- Voice Search Button -->
              <button 
                mat-icon-button
                matTooltip="Search by voice"
                matTooltipPosition="below"
                matTooltipShowDelay="500"
                matTooltipHideDelay="100"
                tabindex="-2"
                (click)="openVoicePopup()"
                [attr.aria-label]="isListening ? 'Stop voice search' : 'Start voice search'"
                [disabled]="!speechRecognitionSupported"
                type="button">
                <mat-icon class="voice-icon">
                  {{ isListening ? 'mic' : 'mic_none' }} 
                </mat-icon> 
              </button>
            </div>
            
            <!-- Spinner -->
            <app-spinner *ngIf="isBusy" [isbusy]="isBusy"></app-spinner>
          </div>
        </mat-card-content>
      </mat-card>
      <!-- ========== POLLING NOTIFICATION (wide-range still-loading state) ========== -->
<mat-card class="polling-card" *ngIf="isPolling">
  <mat-card-content>
    <div class="polling-content">
      <mat-spinner diameter="32"></mat-spinner>
      <div class="polling-text">
        <div class="polling-title">Loading extended order history...</div>
        <div class="polling-message">{{ pollingMessage }}</div>
        <div class="polling-elapsed">Elapsed: {{ pollingElapsedSec }}s</div>
      </div>
    </div>
  </mat-card-content>
</mat-card>


      <!-- ========== VOICE SEARCH POPUP ========== -->
      <div class="popup-overlay" #voicePopup (click)="onVoicePopupClick($event)">
        <div class="popup-content">
          <button class="close-button" (click)="closeVoicePopup()">×</button>
          
          <div class="status-message" #statusMessage></div>
          
          <button class="mic-button" #micButton (click)="toggleRecording()">
            <svg viewBox="0 0 24 24">
              <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
              <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.93V21h2v-3.07c3.39-.5 6-3.4 6-6.93h-2z"/>
            </svg>
          </button>
          
          <div class="recording-indicator" #recordingIndicator></div>
        </div>
      </div>
      <div class="dashboard-search" *ngIf="(orders && orders.length > 0) || isFilterLoading || isSearchPerformed">
        
        <!-- Customer Information Card -->
        <mat-card class="customer-info-card" *ngIf="orders && orders.length > 0">
          <mat-card-header>
            <mat-card-title>
              <span class="customer-information">Customer Information</span>
            </mat-card-title>
          </mat-card-header>
          
          <mat-card-content>
            <div class="customer-details">
              <p>
                <span class="customer-name">
                  <b>{{ this.orders[0].shipToName }}</b><br>
                </span>
                <span class="customer-address" *ngIf="orders?.[0]?.shipToAddress?.houseNumber">{{ this.orders[0].shipToAddress.houseNumber }},</span>
                <span class="customer-address">{{ this.orders[0].shipToAddress.street }}</span>, 
                <span class="customer-address">{{ this.orders[0].shipToAddress.city }}</span>, 
                <span class="customer-address">{{ this.orders[0].shipToAddress.state }}</span>, 
                <span class="customer-address">{{ this.orders[0].shipToAddress.postalCode }}</span>, 
                <span class="customer-address">{{ this.orders[0].shipToAddress.country }}</span>
              </p>
              
              <div class="customer-numbers">
                <div class="ship-to">
                  <span class="label">Ship to:</span>
                  <span class="value">{{ this.orders[0].shipToNumber }}</span>
                </div>
                <div class="sold-to">
                  <span class="label">Sold to:</span>
                  <span class="value">{{ this.orders[0].soldToNumber }}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="orders-section">
          <div class="section-header">
            <div class="orders-header-left">
              <span class="order-header"><b>Orders</b></span>

              <!-- Freshness indicator (shown when 90-day cache hit) -->
              <div class="freshness-indicator"
                  *ngIf="cachedAtLabel"
                  [class.fresh]="cachedAtSeverity === 'fresh'"
                  [class.aged]="cachedAtSeverity === 'aged'"
                  [class.stale]="cachedAtSeverity === 'stale'">
                <mat-icon>schedule</mat-icon>
                <span>{{ cachedAtLabel }}</span>
              </div>

              
            </div>

            <app-spinner *ngIf="isFilterLoading" [isbusy]="isFilterLoading"></app-spinner>

            <button class="filters-button" (click)="openFilterSidenav()" *ngIf="isSearchPerformed" style="border: none !important; outline: none !important; box-shadow: none !important;">
              <span>
                <img 
                  src="assets/newimages/FiltersLarge.png" 
                  alt="">
              </span>
            </button>
          </div>
        </div>

        <!-- No Orders Found Message -->

        <!-- ========== ORDER CARDS ========== -->
        <div *ngIf="orders && orders.length > 0 && !isFilterLoading && !filterReturnedEmpty">
          <div *ngFor="let orderinfo of this.orders">
            <mat-card class="order-card">
              <!-- Order Header -->
              <mat-card-header>
               <mat-card-title class="order-row">
                <span class="order-label">
                 <b>Order # :</b>
                  </span>
                    <span class="order-pill">
                     {{ orderinfo.orderNumber }}
                      </span>
                      <img src="/assets/newimages/threedot.png" class="menu-icon" />
                
                       </mat-card-title>
                       
                <mat-card-subtitle>
                  <div class="ordernew-product-detail">
                    <span class="ordernew-detail-item">
                      Order Created: {{ orderinfo.orderCreationDate | date:'MM/dd/yyyy' }}
                    </span>
                    <span class="ordernew-detail-item">
                      Customer Requested: {{ orderinfo.requestedDeliveryDate | date:'MM/dd/yyyy' }}
                    </span>
                    <span class="ordernew-detail-item">
                      Purchase Order: {{ (orderinfo.customerPONumber) ? orderinfo.customerPONumber : 'N/A' }}
                    </span>
                  </div>
                </mat-card-subtitle>
              </mat-card-header>
              
              <!-- Order Content -->
              <mat-card-content>
                <!-- Deliveries Header -->
                <div class="deliveries-header">
                  <span class="deliveries-title"><b>Deliveries</b></span>
                  <mat-chip-set>
                    <mat-chip>{{ orderinfo.deliveries.length }}</mat-chip>
                  </mat-chip-set>
                </div>

                <!-- ========== DELIVERIES WRAPPER ========== -->
                <div class="deliveries-wrapper">
                  <!-- No deliveries -->
                  <div *ngIf="!orderinfo.deliveries || orderinfo.deliveries.length === 0">
                    <mat-card class="delivery-card status-intransit-card">
                      <mat-card-header>
                        <div class="delivery-header">
                          <div class="delivery-info">
                            <span class="delivery-header-new">
                              <b>Delivery: N/A</b>
                            </span>
                            {{orderinfo.Products[0].orderLineStage | translate}}
                          </div>
                        </div>
                      </mat-card-header>

                      <mat-card-content>
                        <hr>
                        <!-- Use Products Template without filter -->
                        <ng-container *ngFor="let product of orderinfo.Products; let i = index">
                          <div class="products-container">
                            <div 
                              class="product-card" 
                              *ngIf="(i < 3 || showAllItems || orderinfo.Products.length <= 3)">
                              
                              <mat-card-header>
                                <mat-card-title class="product-details">
                                  <b>{{ product.productName }}</b>
                                </mat-card-title>
                                
                                <mat-card-subtitle>
                                  <div class="productnew-detail">
                                    <span class="product-detail-item">
                                      Product ID: {{ product.sKU }}
                                    </span>
                                    <span class="product-detail-item">
                                      Material Availability: {{ product.materialAvailabilityDate | date:'MM/dd/yyyy' }}
                                    </span>
                                    <span class="product-detail-item">
                                      Quantity: {{ product.quantityOrdered }} 
                                    </span>
                                  </div>
                                </mat-card-subtitle>
                              </mat-card-header>
                            </div>
                          </div>
                        </ng-container>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  
                  <!-- Loop through deliveries -->
                  <div *ngFor="let delivery of orderinfo.deliveries; let i = index">
                    <div *ngIf="i < 5 || showMore">
                      <!-- Delivery Card -->
                      <mat-card 
                        class="delivery-card" 
                        [ngClass]="{
                          'status-delivery-card': delivery.deliveryStage === 'Delivered',
                          'status-intransit-card': delivery.deliveryStage === 'In Transit' || 
                                                   delivery.deliveryStage === 'Preparing To Ship' || 
                                                   delivery.orderLineNumRef[0].orderLineStage === 'Order Management' || 
                                                   delivery.orderLineNumRef[0].orderLineStage === 'Stock Availability' || 
                                                   delivery.orderLineNumRef[0].orderLineStage === 'Credit/Pricing Issues',
                          'status-rejected-card':delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' || delivery.deliveryStage === 'Rejected/Cancelled'
                        }">

                        <!-- Delivery Header -->
                        <mat-card-header>
                          <div class="delivery-header">
                            <div class="delivery-info">
                              <span class="delivery-header-new">
                                <b>Delivery: {{ delivery.deliveryNumber ? delivery.deliveryNumber : 'N/A' }}</b>
                              </span>

                              <!-- Status Badges -->
                              <!-- Stock Availability / Not Yet Available -->
                              <div class="delivery-badges"
                                   *ngIf="!delivery.deliveryNumber &&
                                          delivery.orderLineNumRef[0].orderLineStage != 'Rejected/Cancelled' &&
                                          delivery.deliveryStage !== 'Delivered'">
                                <span
                                  class="preparing-layout intransit-status"
                                  [ngStyle]="{'background-color': '#F0F3F5'}">
                                  {{ delivery.orderLineNumRef[0].orderLineStage | translate }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- Rejected/Cancelled -->
                              <div class="delivery-badges"
                                   *ngIf="delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' &&
                                          ((delivery.deliveryStage !== null &&
                                            delivery.deliveryStage === 'Rejected/Cancelled') ||
                                           (delivery.deliveryStage !== null &&
                                            delivery.deliveryStage === '')) &&
                                          delivery.deliveryNumber">
                                <span
                                  class="rejected-layout rejected-status"
                                  [ngStyle]="{'background-color': '#facbbb'}">
                                  {{ delivery.orderLineNumRef[0].orderLineStage | translate }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- Delivered -->
                              <div class="delivery-badges"
                                   *ngIf="delivery.deliveryStage === 'Delivered' &&
                                          delivery.deliveryNumber">
                                <span
                                  class="delivery-layout delivery-status"
                                  [ngStyle]="{'background-color': '#D7F7E7'}">
                                  {{ delivery.deliveryStage }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- In Transit -->
                              <div class="delivery-badges"
                                   *ngIf="delivery.deliveryStage === 'In Transit' &&
                                          delivery.deliveryPlannedGIDate != null &&
                                          delivery.deliveryStage !== 'Delivered' &&
                                          delivery.deliveryNumber">
                                <span
                                  class="intransit-layout intransit-status"
                                  [ngStyle]="{'background-color': '#F0F3F5'}">
                                  {{ delivery.deliveryStage }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- Preparing To Ship -->
                              <div class="delivery-badges"
                                   *ngIf="delivery.deliveryStage === 'Preparing To Ship' &&
                                          (delivery.deliveryPlannedGIDate != null ||
                                           delivery.deliveryGoodsIssueCompleted === null ||
                                           delivery.deliveryGoodsIssueCompleted === 'A' ||
                                           delivery.deliveryGoodsIssueCompleted === 'B') &&
                                          delivery.deliveryStage !== 'Delivered' &&
                                          delivery.deliveryNumber">
                                <span
                                  class="preparing-layout intransit-status"
                                  [ngStyle]="{'background-color': '#F6FAFE'}">
                                  {{ delivery.deliveryStage }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>
                            </div>

                            <!-- Action Buttons -->
                            <div class="button-container">
                              <!-- Download Proof Of Delivery -->
                              <button 
                                class="action-btn pod-wrapper"
                                *ngIf="delivery.deliveryStage == 'Delivered'"
                                (click)="getFileNameById(delivery.deliveryNumber)"
                                [disabled]="currentDownloadingId === delivery.deliveryNumber">
                                <img 
                                  src="assets/newimages/PODDownload.png" 
                                  alt="Download POD"
                                  [style.visibility]="currentDownloadingId === delivery.deliveryNumber ? 'hidden' : 'visible'">
                                <div class="spinner-overlay" *ngIf="currentDownloadingId === delivery.deliveryNumber">
                                  <mat-spinner diameter="20" color="accent"></mat-spinner>
                                </div>
                              </button>
                              &nbsp;
                              
                              <!-- Track Button -->
                              <button 
                                class="action-btn"
                                [disabled]="!delivery.trackUrl" 
                                (click)="showTrackingInfo(delivery.trackUrl)">
                                <img src="assets/newimages/TrackButton.png" alt="">
                              </button>
                            </div>
                          </div>
                        </mat-card-header>

                        <!-- Delivery Content -->
                        <mat-card-content>
                          <!-- Delivery Details Grid -->
                          <div class="delivery-details-grid">
                            <div class="detail-item">
                              <span class="label">Carrier Name:</span>
                              <span class="value">{{ delivery.carrierName ? delivery.carrierName:'N/A' }}</span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">PRO Number:</span>
                              <span class="value">
                                {{ delivery.deliveryProNumber ? delivery.deliveryProNumber : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Origin Name:</span>
                              <span class="value">
                                {{ delivery.deliveryShippingPlant ? delivery.deliveryShippingPlant : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Actual Ship Date:</span>
                              <span class="value">
                                {{ delivery.deliveryGoodsIssueDate ? (delivery.deliveryGoodsIssueDate | date:'MM/dd/yyyy') : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Planned Ship Date:</span>
                              <span class="value">
                                {{ delivery.deliveryPlannedGIDate ? (delivery.deliveryPlannedGIDate | date:'MM/dd/yyyy') : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Estimated Delivery Date:</span>
                              <span 
                                class="value" 
                                *ngIf="delivery.deliveryStage === 'In Transit' || 
                                       delivery.deliveryStage === 'Preparing To Ship'">
                               {{  delivery.actualDeliveryDate ? (delivery.actualDeliveryDate | date:'MM/dd/yyyy') :'N/A' }}
                              </span>
                               <span class="value" *ngIf="delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' || 
                                                         delivery.deliveryStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Stock Availability' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Order Management' ||
                                                          delivery.orderLineNumRef[0].orderLineStage === 'Credit/Pricing Issues'">
                                                          N/A
                                </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Actual Delivery Date:</span>
                              <span 
                                class="value" 
                                *ngIf="delivery.deliveryStage == 'Delivered' && 
                                       (delivery.proofOfDeliveryDateTime != null || 
                                        delivery.hasDropShipItems || 
                                        delivery.actualDeliveryDate != null)">
                                {{ delivery.proofOfDeliveryDateTime ? (delivery.proofOfDeliveryDateTime | date:'MM/dd/yyyy'): (delivery.actualDeliveryDate ? (delivery.actualDeliveryDate | dateFormat): 'N/A') }}
                              </span>
                               <span class="value" *ngIf="delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' || 
                                                         delivery.deliveryStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Stock Availability' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Order Management' ||
                                                          delivery.orderLineNumRef[0].orderLineStage === 'Credit/Pricing Issues'">
                                                          N/A
                                </span>
                            </div>
                          </div>

                          <!-- Tracking Numbers Section -->
                          <div class="delivery-details-grid">
                            <div class="detail-item">
                              <span class="label">Delivery Tracking Numbers:</span>
                              
                              <!-- No tracking numbers -->
                              <div *ngIf="delivery.deliveryTrackingNumber?.length === 0">
                                <span>{{'N/A'}}</span>
                              </div>
                              
                              <!-- Tracking numbers list -->
                              <div class="tracking-list">
                                <span 
                                  class="value" 
                                  *ngFor="let trackingNumber of delivery.deliveryTrackingNumber; 
                                          let last = last; 
                                          let i = index">
                                  <ng-container *ngIf="i < 3 || showMoreTrackNumber">
                                    <span class="tracking-number-wrapper">
                                      <b>{{ trackingNumber.trackingNumber }}</b>
                                      <button 
                                        mat-icon-button 
                                        class="copy-btn" 
                                        (click)="copyToClipboard(trackingNumber.trackingNumber)"
                                        matTooltip="Copy tracking number"
                                        matTooltipPosition="above">
                                        <mat-icon class="copy-icon">content_copy</mat-icon>
                                      </button>
                                    </span>
                                    <span *ngIf="!last && (i < delivery.deliveryTrackingNumber.length - 1)">, </span>
                                    <br *ngIf="(i + 1) % 3 === 0 && !last && (i < 2 || showMoreTrackNumber)">
                                  </ng-container>
                                </span>

                                <!-- Show More/Less button for tracking numbers -->
                                <div 
                                  *ngIf="delivery.deliveryTrackingNumber.length > 5" 
                                  class="show-more-container">
                                  <button 
                                    mat-button 
                                    color="primary" 
                                    class="show-more-btn" 
                                    (click)="toggleShowMoreTrackNumber()">
                                    {{ showMoreTrackNumber ? 'Show Less' : 'Show More' }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <hr>
                          <!-- ========== PRODUCTS SECTION ========== -->
                          <ng-container *ngIf="{ 
                              key: orderinfo.orderNumber + '_' + delivery.deliveryNumber,
                              deliveryProducts: getProductsForDelivery(orderinfo, delivery)
                            } as ctx">
                            <div class="products-wrapper">
                              <ng-container *ngFor="let product of ctx.deliveryProducts; let i = index">
                                <div class="products-container">
                                  <div 
                                    class="product-card" 
                                    *ngIf="i < 3 || isOrderExpanded(ctx.key)">
                                    
                                    <mat-card-header>
                                      <mat-card-title class="product-details">
                                        <b>{{ product.productName }}</b>
                                        <span 
                                          *ngIf="product.orderLineStage !== delivery.deliveryStage && product.orderLineStage === 'Rejected/Cancelled'"
                                          class="product-stage-badge"
                                          [ngClass]="{
                                            'badge-rejected': product.orderLineStage === 'Rejected/Cancelled'
                                            }">
                                            {{ product.orderLineStage | translate }}
                                        </span>
                                      </mat-card-title>
                                      
                                      <div class="productnew-detail-wrapper">
                                        <div class="productnew-detail">
                                          <span class="product-detail-item">
                                            Product ID: {{ product.sKU }}
                                          </span>
                                          <span class="product-detail-item">
                                            Material Availability: {{ product.materialAvailabilityDate | date:'MM/dd/yyyy' }}
                                          </span>
                                          <span class="product-detail-item">
                                            Quantity: {{product.shippedQuantity}} of {{ product.quantityOrdered }} {{ delivery.deliveryWeightUoM }}
                                          </span>
                                        </div>
                                      </div>
                                    </mat-card-header>
                                  </div>
                                </div>
                              </ng-container>

                              <!-- View All Items Button -->
                              <div 
                                class="view-all-items" 
                                *ngIf="ctx.deliveryProducts.length > 3">
                                <button 
                                  mat-button 
                                  color="primary" 
                                  (click)="toggleViewAllItems(ctx.key)">
                                  <span>{{ isOrderExpanded(ctx.key) ? 'Show Less' : 'View All' }}</span>
                                  <mat-icon>{{ isOrderExpanded(ctx.key) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                                </button>
                              </div>
                            </div>
                          </ng-container>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </div>

                  <!-- Show More/Less Button for Deliveries -->
                  <div class="show-more-container" *ngIf="orderinfo.deliveries.length > 5">
                    <button 
                      mat-button 
                      color="primary" 
                      class="show-more-btn" 
                      (click)="toggleShowMore()">
                      {{ showMore ? 'Show less' : 'Show more' }}
                      <mat-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- ========== FOOTER ========== -->
  
</div>

<!-- Chatbot Component -->
<app-filter-side-nav (filtersApplied)="onFiltersApplied($event)"></app-filter-side-nav>
</ng-template>
